// todo: what should these actually be?
export enum VisionDistanceError {
  DistanceError1 = 'distance-error1',
  DistanceError2 = 'distance-error2',
  DistanceError3 = 'distance-error3',
}

export enum VisionCameraError {
  FollowerNoBoard = 'follower-no-board',
  FollowerOutsideRegion = 'follower-outside-region',
  LeaderNoBoard = 'leader-no-board',
  LeaderOutsideRegion = 'leader-outside-region',
}

export enum VisionCameraBoard {
  Field = 'field',
  Manufacturing = 'manufacturing',
  Rapsodo = 'rapsodo',
}

/**
  IVisionCameraCalibration.captureFrames indices and which ICameraError they correspond to:
    * 0-15 -> leader
    * 16-31 -> follower
    * 32-46 -> stereo

  ICameraError.reprojection indices and which capturedFrames indices they correspond to:
    * leader (31 total: 16 leader frames + all stereo frames)
      - 0-15 -> 0-15
      - 16-31 -> 32-46
    * follower (31 total: 16 follower frames + all stereo frames)
      - 0-15 -> 16-31
      - 16-31 -> 32-46
    * stereo (15 total: all stereo frames)
      - 0-14 -> 32-46
*/

export const CALIBRATION_LEADER_FRAME_COUNT = 16;
export const CALIBRATION_FOLLOWER_FRAME_COUNT = 16;
export const CALIBRATION_STEREO_FRAME_COUNT = 15;

export const CALIBRATION_LEADER_ONLY_FRAME_INDICES = Array.from(
  { length: CALIBRATION_LEADER_FRAME_COUNT },
  (_, i) => i // 0-15
);

export const CALIBRATION_FOLLOWER_ONLY_FRAME_INDICES = Array.from(
  { length: CALIBRATION_FOLLOWER_FRAME_COUNT },
  (_, i) => i + 16 // 16-31
);

export const CALIBRATION_STEREO_ONLY_FRAME_INDICES: number[] = Array.from(
  { length: CALIBRATION_STEREO_FRAME_COUNT },
  (_, i) => i + 32 // 32-46
);

export const CALIBRATION_LEADER_FRAME_INDICES: number[] = [
  CALIBRATION_LEADER_ONLY_FRAME_INDICES, // 0-15
  CALIBRATION_STEREO_ONLY_FRAME_INDICES, // 32-46
].flat();

export const CALIBRATION_FOLLOWER_FRAME_INDICES: number[] = [
  CALIBRATION_FOLLOWER_ONLY_FRAME_INDICES, // 16-31
  CALIBRATION_STEREO_ONLY_FRAME_INDICES, // 32-46
].flat();

export enum VisionCalibrationCameraType {
  leader = 'leader',
  follower = 'follower',
  stereo = 'stereo',
}

export enum VisionCameraCalibrationType {
  PlateCalibration = 'plate_calibration',
  FileRecord = 'file_record',
  RemoteCalibration = 'remote_calibration',

  // todo: backfill any existing VCCs that are missing calibration_type with StereoCalibration so we can make it a required field
  StereoCalibration = 'stereo_calibration',
}

export const CALIBRATION_FRAME_INDICES: Record<
  VisionCalibrationCameraType,
  number[]
> = {
  leader: CALIBRATION_LEADER_FRAME_INDICES,
  follower: CALIBRATION_FOLLOWER_FRAME_INDICES,
  stereo: CALIBRATION_STEREO_ONLY_FRAME_INDICES,
};
